import { helper as buildHelper } from '@ember/component/helper';
export default buildHelper(function () {
  return document.documentElement.getAttribute('dir') === 'rtl';
});
